<template>
	<RouterView />
  <CsatPopup v-if="appReady && !route.meta.hideCsat"/>
</template>

<script setup>
import { RouterView, useRoute, useRouter } from 'vue-router';
import { onMounted, watch, ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useLaboratoryStore } from '@/stores/laboratoryStore';
import CsatPopup from "@/components/popup/CsatPopup.vue";
import { useCsat } from "@/services/csat.service.js";
const router = useRouter();

const { checkCsatStatus, registerActivity } = useCsat();
const laboratoryStore = useLaboratoryStore();
const appReady = ref(false);

const handleCsatLogic = () => {
  if (route.meta.hideCsat) return;

  const laboratoryId = laboratoryStore.currentLab?.id;
  if (authstore.token && route.name && laboratoryId) {
    checkCsatStatus(laboratoryId);
    registerActivity(laboratoryId);
  }
};
const authstore = useAuthStore();
const route = useRoute();

onMounted(async() => {
  await router.isReady();
  appReady.value = true;
	authstore.resetCounterRefresh();
  handleCsatLogic()
})

watch(
    () => route.path,
    () => {
      if (appReady.value) {
        handleCsatLogic();
      }
    }
);

</script>

<style>
	#app {
		width: 100%;
		height: 100vh;
    position: relative;
	}
</style>
